import { render, staticRenderFns } from "./RsaSchedaInfermieristicaValutazioneSensorialeEditComponent.vue?vue&type=template&id=6f48785b"
import script from "./RsaSchedaInfermieristicaValutazioneSensorialeEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaInfermieristicaValutazioneSensorialeEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports